import { useEffect, useState, useRef } from 'react';
import fetchAPI from '../utils/fetchAPI';
import { apiUrl } from '../constants/global';

const DEFAULT_CATEGORY_ID = 0;

function useCategories(defaultCategoryOptions: TCategoryOption[], categoryId: number | undefined) {
  const [categories, setCategories] = useState(defaultCategoryOptions);
  const previousCategoryId = useRef(DEFAULT_CATEGORY_ID);

  useEffect(() => {
    if (typeof categoryId === 'undefined' || previousCategoryId.current === categoryId) {
      return;
    }

    previousCategoryId.current = categoryId;

    if (categoryId === DEFAULT_CATEGORY_ID) {
      setCategories(defaultCategoryOptions);
      return;
    }

    async function fetchCategories() {
      const selectedCategory = defaultCategoryOptions?.find(
        (categoryOption) => categoryOption.value === Number(categoryId),
      );
      const categoryKey = selectedCategory?.key;

      if (!categoryKey) {
        return;
      }

      try {
        const categoriesResponse = await fetchAPI({
          url: `${apiUrl}categories?categoryKey=${categoryKey}`,
        });

        setCategories([
          defaultCategoryOptions?.[DEFAULT_CATEGORY_ID],
          ...(selectedCategory?.key === defaultCategoryOptions?.[DEFAULT_CATEGORY_ID]?.key ? [] : [selectedCategory]),
          ...categoriesResponse,
        ]);
      } catch {}
    }

    fetchCategories();
  }, [defaultCategoryOptions, categoryId]);

  return categories;
}

export default useCategories;
